export default __webpack_public_path__ + "static/media/Stars2.cdcae2dc.svg";